const API_KEY = "AIzaSyBCD5ZbG7exctIibdcQrbBoKRigwrnpSaE";

export default API_KEY;
